<select (change)="switchTheme($event)">
  @for (theme of ValidThemes; track theme) {
    <option [value]="theme">{{ theme | titlecase }}</option>
  }
</select>
